(() => {
  'use strict';
  if (customElements.get('mp-stock-almacen')) return;
  const number = value => new Intl.NumberFormat('es-ES', { maximumFractionDigits: 2 }).format(value);
  class StockAlmacen extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('.product-info') || this.parentElement;
      this.message = this.querySelector('template').content.firstElementChild.cloneNode(true);
      this.onCalc = event => {
        if (event.target.dataset.formId !== this.dataset.formId) return;
        this.updateCalculator(event.target);
      };
      this.scope.addEventListener('mp:calc', this.onCalc);
      queueMicrotask(() => {
        if (!this.isConnected) return;
        const calculator = [...this.scope.querySelectorAll('flooring-calculator')].find(calc => calc.dataset.formId === this.dataset.formId);
        if (calculator) this.updateCalculator(calculator);
      });
      this.updateDates();
      // Recalcular si la pestaña sigue abierta al pasar el corte o cambiar de día.
      this.timer = setInterval(() => this.updateDates(), 60000);
    }
    async updateDates() {
      try {
        const holidays = await window.mpEntrega.loadHolidays(this.dataset.holidaysUrl);
        if (!this.isConnected) return;
        const range = window.mpEntrega.window({ holidays });
        this.querySelector('[data-mp-from]').textContent = window.mpEntrega.format(range.from);
        this.querySelector('[data-mp-to]').textContent = window.mpEntrega.format(range.to);
        this.querySelector('[data-mp-stock-dates]').hidden = false;
      } catch { this.querySelector('[data-mp-stock-dates]').hidden = true; }
    }
    updateCalculator(calculator) {
      if (calculator.dataset.mode !== 'm2') { this.message.hidden = true; return; }
      const cta = calculator.querySelector('[data-role="cta"]');
      if (!cta) return;
      if (this.message.parentElement !== calculator) cta.before(this.message);
      const calc = calculator._calc;
      const valid = calc && calc.input > 0 && !calculator.querySelector('[data-role="total"]').hidden;
      this.message.hidden = !valid;
      if (!valid) return;
      // qty ya incluye merma y el redondeo a cajas completas de la calculadora.
      const enough = calc.qty <= Number(this.dataset.stockBoxes);
      this.message.classList.toggle('mp-stock-almacen__message--short', !enough);
      this.message.querySelector('[data-mp-stock-copy]').textContent = enough
        ? `✓ Tenemos tus ${number(calc.input)} m² en almacén.`
        : `Tenemos ${number(Number(this.dataset.stockM2))} m² en almacén. Si necesitas más, `;
      this.message.querySelector('a').hidden = enough;
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.scope?.removeEventListener('mp:calc', this.onCalc);
      this.message?.remove();
    }
  }
  customElements.define('mp-stock-almacen', StockAlmacen);
})();
